<script setup lang="ts">
import { useRoute } from 'vue-router';

import CustomButton from '@/components/CustomButton.vue';
import FilePreview from '@/components/files/FilePreview.vue';
import { useAuthStore } from '@/stores/auth';
import { downloadFileFromPath, getFileName } from '@/utils/file';
import toast from '@/utils/toast';

const route = useRoute();
const authStore = useAuthStore();

const organizationId = authStore.getCurrentOrganization()._id as string;
const moduleName = route.params.module as string;

if (!organizationId) toast.error('OrganizationRequired');

if (!moduleName) toast.error('ModuleRequired');

const path = `${moduleName}/${route.params.path}` as string;

const fileName = getFileName(path);
</script>

<template>
    <v-fade-transition>
        <div v-if="fileName !== ''">
            <v-row class="pa-3 justify-space-between">
                <h2 class="text-main font-weight-bold">{{ fileName }}</h2>
                <CustomButton class="my-4" @click="downloadFileFromPath(organizationId, path)" text="Bestand downloaden" />
            </v-row>

            <FilePreview :src="path" v-if="path" />
        </div>
    </v-fade-transition>
</template>
